module.exports = __webpack_public_path__ + "img/icon-radar-light.753a9115.svg";